module.exports = __webpack_public_path__ + "static/media/Snow Mood (yenia).6b5408fa.mp3";